<div class="pageTitle">
  {{title}}
  <i class="material-icons pullfloat-right" (click)="closeSetting()"  title="close">close</i>
</div>
<div class="component-wrapper">
</div>